import React from 'react';
import PropTypes from 'prop-types';
import RadioButton from '../radio-button';
import {Form as BsForm} from 'react-bootstrap';
import FormContext from '../../contexts/form-context';
import FieldChangedIndicator from '../field-changed-indicator';
import get from '../../utils/get';

export default function FormRadioButtonGroup(props) {
  const {name, label, options, groupProps, ...rest} = props;
  const {values, initialValues, setFieldValue, handleChange, handleBlur} = React.useContext(FormContext);

  return (
    <BsForm.Group {...groupProps}>
      {options.map(option => (
        <RadioButton
          name={name}
          key={option.value}
          value={option.value}
          checked={option.value === get(values, name)}
          label={label || `property.${option.value}`}
          onChange={handleChange}
          onBlur={handleBlur}
          {...rest}
        />
      ))}
      <FieldChangedIndicator
        name={name}
        originalValue={get(initialValues, name)}
        value={get(values, name)}
        onRevert={setFieldValue}
      />
    </BsForm.Group>
  );
}

FormRadioButtonGroup.defaultProps = {
  groupProps: {},
};

FormRadioButtonGroup.propTypes = {
  /** Name for the form control. */
  name: PropTypes.string.isRequired,
  /** An i18n key to use as a label. Default is `property.${name}`. */
  label: PropTypes.string,
  /** Additional props to pass to the FormGroup */
  groupProps: PropTypes.object,
  options: PropTypes.array,
};
